import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [LIST_PLANS_TECHS, LIST_PLANS_TECHS_SUCCESS, LIST_PLANS_TECHS_FAILURE] =
  createRequestActionTypes('tech/LIST_PLANS_TECHS');

export const listPlanTechs = createAction(
  LIST_PLANS_TECHS,
  (searchData) => searchData,
);
const listPlanTechsSaga = createRequestSaga(
  LIST_PLANS_TECHS,
  techApi.getPlanTechs,
);

const UNLOAD_PLANS_TECHS = 'tech/UNLOAD_PLANS_TECHS';
export const unloadPlanTechs = createAction(UNLOAD_PLANS_TECHS);

export function* PlanTechsSaga() {
  yield takeLatest(LIST_PLANS_TECHS, listPlanTechsSaga);
}

const initialState = {
  techs: null,
  error: null,
};

const planTechs = handleActions(
  {
    [LIST_PLANS_TECHS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techs: data.list.map((tech) => ({
        id: tech.reqUuid,
        reqUuid: tech.reqUuid,
        planUuid:tech.planUuid,
        prjUuid: tech.prjUuid,
        // reqNo: tech.reqNo, //reqNo
        // reqGrade: tech.reqGrade,
        // reqStatus: tech.reqStatus,
        // custNm: tech.custNm,
        // custEmpNm:tech.custEmpNm,//담당자명
        // workTyp:tech.workTyp,
        // workStDt: tech.workStDt,
        // workEdDt: tech.workEdDt,
        // workEmpNm:tech.workEmpNm,
       
        planNo:tech.planNo,
        plnTitle: tech.plnTitle,
        plnTyp: tech.plnTyp,
        plnStrtDt: tech.plnStrtDt,
        plnEndDt: tech.plnEndDt,
        plnContext: tech.plnContext,
        plnUsr: tech.plnUsr,
        plnNm: tech.plnNm,
       
        rsltUuid: tech.rsltUuid,
        useYn: tech.useYn,
        crtNm: tech.crtNm,
        crtDt: tech.crtDt,
        cngNm: tech.cngNm,
        cngDt: tech.cngDt,
      })),
      error: null,
    }),
    [LIST_PLANS_TECHS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_PLANS_TECHS]: () => initialState,
  },
  initialState,
);

export default planTechs;
